<template>
    <el-dialog :title="title" :visible.sync="dialogFormVisible" @close="close" :close-on-click-modal="false" :close-on-press-escape="false" width="900px">
        <el-form size="small" :model="form" :rules="formRules" :label-width="formLabelWidth" ref="form">

            <el-form-item label="状态">
                <el-radio-group v-model="form.status">
                    <el-radio :label="0">待审核</el-radio>
                    <el-radio :label="1">审核通过</el-radio>
                    <el-radio :label="2">审核驳回</el-radio>
                </el-radio-group>
            </el-form-item>

            <el-form-item label="审核说明" prop="address">
                <el-input type="textarea" v-model="form.remark" placeholder="审核说明" clearable/>
            </el-form-item>

        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="close">取 消</el-button>
            <el-button type="primary" @click="save" :disabled="submit_loading">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
    import {auditDetail, auditEdit } from '@/api/education';

    export default {
        components: {  },
        data() {
            return {
                title: '',
                form: {
                    audit_id: '',
                    target_id: '',
                    audit_type: '',
                    remark: '',
                    status: 1,
                },
                file_path: '',
                /*左边长度*/
                formLabelWidth: '120px',
                /*是否显示*/
                dialogFormVisible: false,
                /*是否正在提交*/
                submit_loading: false,
                // 验证
                formRules: {
                    name: [{
                        required: true,
                        message: '请输入标题',
                        trigger: 'blur'
                    }]
                },
            };
        },
        props: ['fetch-data'],
        created() {

        },
        methods: {
            showDialog(row) {
                console.log(row, '')
                if (!row) {
                    this.title = '审核'
                } else {
                    this.title = '审核'
                    this.form.target_id = row.target_id
                    this.form.audit_type = row.audit_type
                    this.form.audit_id = row.audit_id
                }
                if(this.form.audit_id > 0){
                    this.getDetail()
                }
                this.dialogFormVisible = true
            },
            // 关闭
            close() {
                this.$refs['form'].resetFields()
                this.form = this.$options.data().form
                this.dialogFormVisible = false
            },
            // 保存
            save() {
                this.$refs['form'].validate(async (valid) => {
                    if (valid) {
                        this.submit_loading = true
                        this.form.detail = []
                        auditEdit(this.form).then((result)=>{
                            this.$message({message: result.msg, type: 'success'});
                            this.$emit('fetch-data')
                            this.submit_loading = false
                            this.close()
                        }).catch(()=>{
                            this.submit_loading = false
                        })
                    }
                })
            },
            getDetail(){
                auditDetail({id: this.form.audit_id, audit_type: this.form.audit_type}).then((result)=>{
                    if(result.data.target_id > 0){
                        this.form = Object.assign({}, result.data)
                    }
                })
            },
        }
    };
</script>

<style scoped>
    .tips {
        color: #ccc;
    }
</style>



// WEBPACK FOOTER //
// src/views/education/audit/audit.vue